// Copyright (c) 2019 Deere & Company

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import BusyCounterLoadingIndicator from '../../../../shared/components/busyCounter/busy-counter-loading-indicator';

export const AuthenticatedPage = props => (
    <div className={props.className}>
        { props.accessToken && props.children }
        { !props.accessToken && <BusyCounterLoadingIndicator busyCounter={true}/> }
    </div>

);

AuthenticatedPage.displayName = 'AuthenticatedPage';
AuthenticatedPage.propTypes = {
    accessToken: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
};

const mapStateToProps = state => ( {
    accessToken: state.oktaState.oktaState.accessToken,
} );

export default connect(
    mapStateToProps,
)( AuthenticatedPage );
